import moment from 'moment';
import React, { useEffect, useState } from 'react';

const MinutesTimer: React.FC<{ targetTime: string | null }> = ({
  targetTime,
}) => {
  const [AssignedMinutes, setAssignedMinutes] = useState('');

  const calculateDifference = () => {
    if (targetTime === null) {
      return { hours: 0, minutes: 0, totalMinutes: 0 };
    }
    const giventimeToLocal = moment
      .utc(targetTime + 'Z')
      .local()
      .valueOf();

    const CurrentLocalTime = moment().local().valueOf();
    const diffMilliseconds = CurrentLocalTime - giventimeToLocal;

    if (diffMilliseconds < 0) {
      console.log(
        'GivenTime',
        moment
          .utc(targetTime + 'Z')
          .local()
          .format('YYYY-MM-DD HH:mm:ss')
      );
      console.log('giventimeToLocal', giventimeToLocal);
      console.log(
        'CurrentLocalTime',
        moment().local().format('YYYY-MM-DD HH:mm:ss')
      );
      console.log('CurrentLocalTime', CurrentLocalTime);
      return { minutes: 0, totalMinutes: 0 };
    }
    const totalMinutes = Math.floor(diffMilliseconds / (1000 * 60));
    const minutes = totalMinutes % 60; // Calculate remaining minutes

    return { minutes, totalMinutes };
  };

  const formatDateTime = () => {
    if (targetTime === null) {
      return { hours: 0, minutes: 0, totalMinutes: 0 };
    }

    const target = moment.utc(targetTime + 'Z').local();

    // Extract time in HH:MM format
    const time = target.format('HH:mm');

    // Extract date in MM/DD format
    const date = target.format('MM/DD');

    return { time, date };
  };

  const startTimer = () => {
    const { totalMinutes } = calculateDifference();

    // Update the assigned minutes dynamically
    if (totalMinutes < 60) {
      setAssignedMinutes(
        `Assigned ${String(totalMinutes).padStart(2, '0')} mins ago`
      );
    } else {
      const { time, date } = formatDateTime();
      // Handle cases where targetTime is in the future (optional)
      setAssignedMinutes(`Assigned at ${time} on ${date}`);
    }
  };

  useEffect(() => {
    startTimer(); // Calculate the difference immediately

    const interval = setInterval(() => {
      startTimer();
    }, 60000); // Update every minute

    return () => clearInterval(interval); // Cleanup on unmount
  }, [targetTime]);

  return <span>{AssignedMinutes}</span>;
};

export default MinutesTimer;
